<div class="meetbusiness-background">
  <div class="container casestudies-body">
    <div class="row">
      <div class="col-md-6 py-5">
        <p class="text-white link-casestudy"><span (click)="nav('/')">Home</span> / <span (click)="nav('/kalpita-case-studies/case-study')">Case Studies</span></p>
          <h1 class="py-3 meet-heading">Meet your business goals with proven ERP methodologies at your fingertips.</h1>
          <p class="py-3 meet-para">
            Kalpita Technologies is well versed in assisting businesses, adapt their workforce to business strategy
            with customized agile roadmaps to lower cost, improve ROI and boost productivity with innovative integrated solutions services on the SAP HCM & SF modules.
          </p>
          <div class="service-industry py-3">
             <div class="industry-box"><h6>Industry:<span class="enterprise">Enterprise</span></h6></div>
             <div class="service-box"><h6>Service:<span>Software Support</span></h6></div>
          </div>
      </div>
      <div class="col-md-6 meetbusi-computer">
        <img src="../../../../assets/resources/casestudies/meetbusiness-computer.webp" class="img-fluid" alt="meetcompute">
      </div>
    </div>
  </div>
</div>
<!-- We have offered our services.............................................................. -->
<div class="geo-background img-fluid">
<h5 class="offer-head">We have offered our services</h5>

</div>

<!-- Our core competencies in ERP implementation includes.......................................... -->
<div class="container">
  <div class="row">
    <div class="col-md-6 pt-5">
      <h5 class="service-head">Our core competencies in ERP implementation includes:</h5>
      <ul>
        <li class="ico-img">Organizational Management</li>
        <li class="ico-img">Personnel Administration</li>
        <li class="ico-img">Personnel Development (Career & Succession Planning, Development Plans)</li>
        <li class="ico-img"> Appraisals (Objective Settings & Appraisals)</li>
        <li class="ico-img">Event Management</li>
        <li class="ico-img">Time Management</li>
        <li class="ico-img"> Payroll</li>
        <li class="ico-img">ESS and MSS modules.</li>
      </ul>
    </div>

    <div class="col-md-6 corecompet-background">
          <h5 class="text-white ps-3 py-5 solution-heading">We specialize in providing ERP solutions to organisations with expertise in SAP, HCM, and SuccessFactors.</h5>
          <div class="ps-5 py-3 text-white solution-data">
           <ul>
            <li class="ico-img-sky">Implemented cloud-based solution to manage various HR functions on the SAP, HCM and SF modules.</li>
            <li class="ico-img-sky">Expertise in maintaining schema and PCRs as per client’s requirements.</li>
            <li class="ico-img-sky">End-to-end payroll module implementation experiences for various countries.</li>
            <li class="ico-img-sky">Assisted in business alignment, people performance, recruitment, and learning activities.</li>
           </ul>
          </div>
    </div>
  </div>
</div>
<!-- Our 5-step process to implementing the SAP............................................... -->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-6 five-steps">
     <h2>Our 5-step process to implementing the SAP:</h2>
    </div>
    <div class="col-md-6 project-prepare">
      <h6>Phase 1: Project preparation:</h6>
      <p>With thorough understanding of the customer segment we provide complete requirement study,
        Solution design and Project Planning in preparation of your SAP project.</p>
    </div>
    <div class="col-md-6 business-blueprint">
      <h6>Phase 2: Business blueprint</h6>
      <p>We provide detailed documentation of the process to initiate the collective understanding of how SAP
        system will operate with base line configuration, Analysis.</p>
    </div>
    <div class="col-md-6 realization">
      <h6>Phase 3: Realization</h6>
      <p>The system configuration methodology is provided in two work packages:</p>
        <ul>
          <li class="ico-img-sky">Baseline configuration (major scope).</li>
          <li class="ico-img-sky">Final configuration (remaining scope).</li>
        </ul>

    </div>
    <div class="col-md-6 final-prepare">
      <h6>Phase 4: Final Preparation</h6>
      <p>Designed to resolve all critical open issues, the SAP system in this stage undergoes finalizing your readiness to go live:</p>
    <ul>
      <li class="ico-img-sky">Testing</li>
      <li class="ico-img-sky">End user training</li>
      <li class="ico-img-sky">System management</li>
      <li class="ico-img-sky">Cutover activities</li>
    </ul>
    </div>
    <div class="col-md-6 golive">
       <h6>Phase 5: Go Live </h6>
       <p>In this phase we move from a project-oriented, pre-production environment to live production operation.</p>
    </div>
  </div>
</div>
<!-- Some company projects we worked on secton..................................................... -->
<div class="container">
  <div class="row">
    <h2 class="py-5 somecompany-heading">Some company projects we worked on:</h2>
    <div class="col-md-6">
      <ul class="company-projects">
        <li class="project-list">America Washington DC -for State Govt. of Florida, Tallahassee</li>
        <li class="project-list">University of Mississippi, Oxford, USA</li>
        <li class="project-list">University of Tennessee, Knoxville, USA</li>
        <li class="project-list">TIC, Steamboat Springs, CO, USA</li>
        <li class="project-list">Nielsen USA (Asia Pacific region, for 9 countries)</li>
        <li class="project-list">Marathon Oil Company, Houston, USA.</li>
        <li class="project-list">Pinnacle Talents Inc, Chicago, USA. CISCO (Singapore).</li>
      </ul>
    </div>

    <div class="col-md-6">
      <ul class="company-projects">
        <li class="project-list">National Panasonic, Singapore; KJO, Al-Khafji,</li>
        <li class="project-list">KSA (Kingdom of Saudi Arabia);</li>
        <li class="project-list">Bahrain Steel, Bahrain; RasGas, Qatar; DUSUP,
          Dubai; DRC, Dubai; ARC, Ras-AL-Khaimah; Emirates Steel, Abu Dhabi; KOEING Solutions, DUBAI, UAE</li>
          <li class="project-list">Reliance India; Siemens India,
            BSNL, Ahmadabad, India; ABB India (South Asian region, for 12 countries); GMR India; TRF India; Ashok Leyland India;
            RAIN Commodities Ltd, India; United India Insurance Company Ltd (UIIC), India; Wipro Ltd, Bangalore, India; Karle Group,
            Bangalore, India; Airtel Delhi & Airtel Africa, India; Neyveli Lignite Corporation, Neyveli, India; Indian Tobacco Company
            (ITC), Guntur, India; Indian Defense – Army, Delhi, India; IISc, Bangalore, India; NADEC project, in EC payroll (ECP) for KSA,
             UAE, Kuwait, Qatar, Bahrain and Sudan.</li>
      </ul>
    </div>
  </div>
</div>

